



































  import {Component, Mixins, Prop, Vue} from 'vue-property-decorator'
  import Cookies from 'js-cookie'
  import {removeToken} from '@/utils/cookies'
  import storeMixin from '@/utils/storeMixin';
  import _ from 'lodash'
  import {wt} from '@/api'
  import chooseAddress from '@/components/chooseAddress.vue'
  import changePwds from '@/components/changePwd.vue'
import { log } from 'node:console';
import store from '@/store';

  @Component({
    name: 'camp',
    components: { chooseAddress, changePwds }
  })
  export default class extends Mixins(storeMixin) {
    public $refs!: {
      address: HTMLFormElement,
      passwords: HTMLFormElement,
    }

    private tableData: any = [];
    private showDiag = false;
    private loginName:any = ''
    private formData: any = {
      AppName: '',
      token: Cookies.get('token')
    }
    private typeList:any = [
      {
        name: '全部',
        value: 'all'
      }
    ]
    private isActive:any = 'all'
    private isLoading:any = true
    private color:any = ['#FFAA12','#327CE2','#49AF99','#9E82FC','#67A0F8']

    async created() {
		let data:any = await wt.Application_GetAll()
			data.map((val:any)=>{
				val.showClose = true
			})
		this.tableData = data
		this.isLoading = false
		this.loginName = Cookies.get('loginName')
		let routeLink:any = this.$route.query.path?this.$route.query.path:''
		let routeArr:any = routeLink.split('/')
		let sysData:any = {
			Name: '',
			Url: routeLink,
			showClose: false
		}
		routeArr.map((val:any,index:any)=>{
			if(index==3){
				sysData.Name = val
			}
		})
		if(routeLink){
			this.toDetail(sysData)
		}
    }

    async changeLi(value:any){
      	this.isActive = value.value
    }

    async handleCommand(command:any){
		if(command=='out'){
			Cookies.remove('loginName')
			Cookies.remove('token')
			this.$router.push('./login')
		}
		if(command=='changePwd'){
			this.$refs.passwords.open()
		}
    }

    async mounted() { }

    async toDetail(item:any){
		this.formData.AppName = item.Name
		let identity:any = await wt.Identity_Power(this.formData)
		// Data.length==1时，直接打开新窗口
		if(identity['Data'].length==1){
      		let list = { appName: item.Name, value: identity['Data'][0].Value, token: Cookies.get('token')}
			console.log(list);
			
      		wt.Identity_SwitchLogin(list).then((res:any) => {
				if(res['Success']){
					window.open(item.Url+'?token='+Cookies.get('token'))  // 打开新窗口
				}
				else{
					// this.$message({
					//   message: res['Content'],
					//   type: 'error'
					// });
				}
			})
		}
		else if(identity['Data'].length>1){
			this.$refs.address.open(item,identity['Data'])  // 打开弹窗
		}
		else{

		}
    }
  }
